import React from "react";
import { Box, Typography, Button } from "@mui/material";
import "./ContentHeader.css";

const ContentHeader = ({ title, buttonLabel, onButtonClick, secondaryButtonLabel, onSecondaryButtonClick }) => {
    return (
        <Box className="content-header">
            <Typography variant="h4" className="content-header-title">
                {title}
            </Typography>
            <Box className="content-header-buttons">
                {secondaryButtonLabel && onSecondaryButtonClick && (
                    <Button 
                        className="content-header-button secondary-button" 
                        onClick={onSecondaryButtonClick}
                        variant="outlined"
                    >
                        {secondaryButtonLabel}
                    </Button>
                )}
                {buttonLabel && onButtonClick && (
                    <Button 
                        className="content-header-button primary-button" 
                        onClick={onButtonClick}
                        variant="contained"
                    >
                        {buttonLabel}
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default ContentHeader;
